import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  useMediaQuery,
  Flex,
  Box,
} from '@chakra-ui/react';
import { connect } from 'react-redux';

import Cross from 'components/Icons/Cross';
import { SetTabs, SetUserModalVisible } from 'redux/UserSlice';

import UserTeamsComponent from '../UserTeams';
import UserBillingComponent from '../UserBilling';
import AddTeamMemberComponent from '../AddTeamMember';
import UserPlansComponent from '../UserPlans';

import ProfileFormNew from './ProfileFormNew';
import OrganisationFormNew from './OrganisationFormNew';
import UserSidebarNew from './UserSidebarNew';

interface Properties {
  userTabs: number;
  isUserModalVisible: boolean;
  setUserModalVisible: (status: boolean) => void;
  setUserTabs: (value: number) => void;
}

const UserModalNew = ({
  userTabs,
  isUserModalVisible,
  setUserTabs,
  setUserModalVisible,
}: Properties) => {
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const [isLaptop] = useMediaQuery('(max-width: 1024px)');

  return (
    <Modal
      isOpen={isUserModalVisible}
      onClose={() => {
        setUserTabs(1);
        setUserModalVisible(false);
      }}
    >
      <ModalOverlay bg='none' backdropFilter='auto' backdropInvert='3%' backdropBlur='4px' />
      <ModalContent
        color='black.900'
        padding='0'
        width={isMobile ? '90%' : { base: '700px', sm: '800px', '4xl': '1500px' }}
        maxWidth={'90%'}
        height='80%'
      >
        <ModalBody padding='0' height={'100%'}>
          <Flex width={'100%'} height={'100%'}>
            {!isMobile && (
              <Box
                width={'20%'}
                bgColor='#6B5FC6'
                padding={isLaptop ? '2rem 1rem' : '2rem'}
                // margin={isLaptop ? '1rem 0' : '1rem'}
                borderRadius='10px 0 0 10px'
              >
                <UserSidebarNew />
              </Box>
            )}
            <Box
              width={!isMobile ? '80%' : '100%'}
              height={'100%'}
              bgColor='white'
              padding={isLaptop ? '2rem 1rem' : '2rem'}
              // margin={isMobile ? '1rem' : '1rem 1rem 1rem 0'}
              borderRadius={isMobile ? '10px' : '0 10px 10px 0'}
            >
              <Box width={'100%'} height={'100%'} position='relative'>
                <Box position={'absolute'} top={'0'} right='0' zIndex={10}>
                  <Cross
                    width={8}
                    height={8}
                    bgColor='black.900'
                    onClick={() => {
                      setUserTabs(1);
                      setUserModalVisible(false);
                    }}
                  />
                </Box>
                <Box height={'100%'}>
                  {userTabs === 1 ? (
                    <ProfileFormNew />
                  ) : userTabs === 2 ? (
                    <OrganisationFormNew />
                  ) : userTabs === 3 ? (
                    <UserTeamsComponent type={1} />
                  ) : userTabs === 4 ? (
                    <UserBillingComponent />
                  ) : userTabs === 5 ? (
                    <UserPlansComponent />
                  ) : userTabs === 8 ? (
                    <AddTeamMemberComponent />
                  ) : userTabs === 9 ? (
                    <UserTeamsComponent type={2} />
                  ) : (
                    ''
                  )}
                </Box>
              </Box>
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

const stateToProperty = (state: any) => {
  return {
    userTabs: state.userSlice.userTabs,
    isUserModalVisible: state.userSlice.isUserModalVisible,
  };
};

const mapDispatchToProperties = (dispatch: any) => {
  return {
    setUserTabs: (data: number) => dispatch(SetTabs(data)),
    setUserModalVisible: (data: any) => dispatch(SetUserModalVisible(data)),
  };
};

export default connect(stateToProperty, mapDispatchToProperties)(UserModalNew);
